import { SvgIcon, SxProps } from '@mui/material';

const Print = ({ sx }: { sx?: SxProps }) => {
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 16, height: 16, fill: 'none', ...sx }}
      data-testid="printIcon"
    >
      <path
        d="M5.66732 10.57C5.66732 10.2938 5.89118 10.07 6.16732 10.07H10.5007C10.7768 10.07 11.0007 10.2938 11.0007 10.57C11.0007 10.8461 10.7768 11.07 10.5007 11.07H6.16732C5.89118 11.07 5.66732 10.8461 5.66732 10.57Z"
        fill="#0B1421"
      />
      <path
        d="M6.16732 11.4033C5.89118 11.4033 5.66732 11.6272 5.66732 11.9033C5.66732 12.1795 5.89118 12.4033 6.16732 12.4033H10.5007C10.7768 12.4033 11.0007 12.1795 11.0007 11.9033C11.0007 11.6272 10.7768 11.4033 10.5007 11.4033H6.16732Z"
        fill="#0B1421"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7229 5.26123V4.16042C12.7229 3.62519 12.489 3.11669 12.0826 2.76839L10.9227 1.77431C10.5905 1.48954 10.1673 1.33301 9.72968 1.33301H5.33398C4.32146 1.33301 3.50065 2.15382 3.50065 3.16634V5.26123H2.66732C1.93094 5.26123 1.33398 5.85818 1.33398 6.59456V10.3559C1.33398 11.0922 1.93094 11.6892 2.66732 11.6892H3.50065V12.4033C3.50065 13.4158 4.32146 14.2367 5.33398 14.2367H11.334C12.3465 14.2367 13.1673 13.4158 13.1673 12.4033V11.6892H13.334C14.0704 11.6892 14.6673 11.0922 14.6673 10.3559V6.59456C14.6673 5.85818 14.0704 5.26123 13.334 5.26123H12.7229ZM5.33398 2.33301C4.87375 2.33301 4.50065 2.7061 4.50065 3.16634V5.26123H11.7229V4.47566H10.2228C9.94668 4.47566 9.72283 4.2518 9.72283 3.97566V2.33301H5.33398ZM10.7228 2.92001L11.3711 3.47566H10.7228V2.92001ZM5.33398 9.23665C4.87375 9.23665 4.50065 9.60975 4.50065 10.07V12.4033C4.50065 12.8636 4.87375 13.2367 5.33398 13.2367H11.334C11.7942 13.2367 12.1673 12.8636 12.1673 12.4033V10.07C12.1673 9.60975 11.7942 9.23665 11.334 9.23665H5.33398Z"
        fill="#0B1421"
      />
    </SvgIcon>
  );
};

export default Print;
